export default __webpack_public_path__ + "static/media/menu2.50ebbcaf.jpg";